import React from 'react'
import { renderToString } from 'react-dom/server'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import { LazyDiv } from 'components/common/LazyHtml'
import { ToggleLink } from 'components/common/Link/Link'
import { generateAdaptiveContent } from './helpers'

const ServiceDescription = ({
  expanded,
  description = '',
  innerWidth,
  toggleOnClick
}) => <ServiceDescriptionWrapper>
  <LazyDiv
    data-html-block
    content={ generateAdaptiveContent({
      description,
      innerWidth,
      expanded,
      component: renderToString(
        <CustomToggleLink
          tabIndex="0"
          role="button"
          aria-expanded={ expanded }>
          { expanded ? 'Read Less' : 'Read More'}
        </CustomToggleLink>)
    }) }
    onClick={ toggleOnClick } />
</ServiceDescriptionWrapper>

ServiceDescription.propTypes = {
  description: PropTypes.string,
  expanded: PropTypes.bool,
  innerWidth: PropTypes.number,
  toggleOnClick: PropTypes.func
}

export default ServiceDescription

const ServiceDescriptionWrapper = styled.div`
  ${Media.mobile`
    margin-left: 45px;
  `}

  & li {
    list-style: disc;
  }
`
const CustomToggleLink = styled(ToggleLink)`
  cursor: pointer;
  margin-left: 5px;
`
